import SubLinks from '../../components/header/SubLinks.jsx';
import BackArrow from '../../components/common/BackArrow.jsx';
import { adminLinks } from '../../config/standard-links.js';
import BpForm from '../../components/admin-automations/BpForm.jsx';

const BpRemoval = () => {
    return (
        <div>
            <SubLinks links={adminLinks} />
            <div className="newsc-container">
                <br />
                <br />
                <br />
                <div className="create-office-heading">
                    <BackArrow navigateTo={-1} />
                    <h2>Create BP Access Removal Ticket</h2>
                </div>
                <br />
                <BpForm />
            </div>
        </div>
    );
};

export default BpRemoval;
